import { Step, StepStatus } from "./types";
import {
  IdCardIcon,
  DocumentIcon,
  ReferencesIcon,
  BriefcaseIcon,
  BlueQuestionIcon,
  HomeIcon,
} from "./Icons"; // Changed UserIcon to IdCardIcon, UsersIcon to ReferencesIcon

export const toAbsoluteUrl = (pathname: any) =>
  process.env.PUBLIC_URL + pathname;
export const INITIAL_STEPS: Step[] = [
  {
    id: 1,
    title: "Upload ID / Drivers License",
    status: StepStatus.PENDING,
    icon: IdCardIcon, // Changed from UserIcon
  },
  {
    id: 4,
    title: "Update Income",
    status: StepStatus.PENDING,
    icon: BriefcaseIcon,
  },
  {
    id: 2,
    title: "Upload Insurance",
    status: StepStatus.PENDING,
    icon: DocumentIcon,
  },
  {
    id: 6,
    title: "Upload Residence",
    status: StepStatus.PENDING,
    icon: HomeIcon,
  },
  {
    id: 3,
    title: "Share a few references",
    status: StepStatus.PENDING,
    icon: ReferencesIcon, // Changed from UsersIcon
  },

  {
    id: 5,
    title: "Just a few questions",
    status: StepStatus.PENDING,
    icon: BlueQuestionIcon,
  },
];

export const HIDE_QUESTIONS_STEP_STATUSES = [
  "MR",
  "ERR",
  "CB_ERR",
  "A",
  "AA",
  "AC",
  "C",
  "D",
  "AD",
  "RD",
];

export const USER_NAME = "";

export enum UploadDocumentType {
  DRIVERS_LICENSE = "DriversLicense",
  INSURANCE = "Insurance",
  INCOME = "Income",
  BANK_STATEMENT = "BankStatement",
  PAYROLL_DOCUMENT = "PayrollDocument",
  RESIDENCE = "Residence",
}

export const tokenValue = "dwtTk";
export const customerInfoIdValue = "cuId";
export const userNameValue = "usNm";

export const localStorageConstants = [
  tokenValue,
  customerInfoIdValue,
  userNameValue,
];

export const commonUploadInputAcceptTypes =
  "image/png,image/jpeg,image/bmp,image/gif,image/heic,image/heif,application/pdf";

export const googleTagMgrId = "GTM-5LH7RRP2";

export const CO_APPLICANT_STEP_IDS = [1, 4, 6, 3];

export const getStepsForApplicantType = (
  isCoApplicant: boolean,
  appStatus?: string | null,
): Step[] => {
  if (isCoApplicant) {
    return INITIAL_STEPS.filter((step) =>
      CO_APPLICANT_STEP_IDS.includes(step.id),
    );
  }

  const steps = INITIAL_STEPS.map((step) => ({ ...step }));

  if (HIDE_QUESTIONS_STEP_STATUSES.includes(appStatus ?? "")) {
    return steps.filter((step) => step.id !== 5);
  }

  return steps;
};

export const H_QJN_REM = 3.5; // QuickJumpNav height
export const H_MBN_CONTENT_REM = 4; // MobileBottomNav height
